var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFashionRightImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 131,
    viewBox: "0 0 211 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.519531 115.86L13.6095 107.53",
    stroke: "#FA5252",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.69 83.7799L204.84 75.6299L200.71 84.7699L210.69 83.7799Z",
    fill: "#FF8787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.79 86.32C103.39 86.32 102.99 86.17 102.68 85.86L99.81 82.99C99.2 82.38 99.2 81.39 99.81 80.77C100.42 80.16 101.41 80.16 102.03 80.77L104.9 83.64C105.51 84.25 105.51 85.24 104.9 85.86C104.59 86.16 104.19 86.32 103.79 86.32Z",
    stroke: "#FA5252",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.78 65.2902C183.076 65.2902 188.18 60.1863 188.18 53.8902C188.18 47.5942 183.076 42.4902 176.78 42.4902C170.484 42.4902 165.38 47.5942 165.38 53.8902C165.38 60.1863 170.484 65.2902 176.78 65.2902Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.88 63.7404C184.176 63.7404 189.28 58.6365 189.28 52.3404C189.28 46.0444 184.176 40.9404 177.88 40.9404C171.583 40.9404 166.479 46.0444 166.479 52.3404C166.479 58.6365 171.583 63.7404 177.88 63.7404Z",
    fill: "#FFA8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.08 53.0206C183.75 56.6906 174.84 56.7806 174.84 56.7806C174.84 56.7806 172 48.5806 175.29 46.8206C179.27 44.6906 179.68 49.9206 179.68 49.9206C179.68 49.9206 184.46 48.7606 184.08 53.0206Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.77 48C168.25 51.57 169.1 56.51 172.67 59.03",
    stroke: "white",
    strokeWidth: 1.0219,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4751 22.8736L4.50781 27.4736L9.10781 35.4408L17.0751 30.8408L12.4751 22.8736Z",
    fill: "#FFA8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.45 6.38031L174.71 2.32031L174.07 9.32031L180.45 6.38031Z",
    fill: "#FF8787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0098 9.63965L48.9397 26.6496",
    stroke: "#FA5252",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.06 20.0996L186.67 29.2496",
    stroke: "#FA5252",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.25 15.5801L101.86 24.7401",
    stroke: "#FA5252",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.99 104.42L171.67 87.4102",
    stroke: "#FA5252",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.5 117.27L172.03 101.57",
    stroke: "#FA5252",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 33.85L104.72 1",
    stroke: "#FA5252",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4297 88.78C35.5097 88.28 38.4497 89.31 38.7897 90.45",
    stroke: "#FA5252",
    strokeWidth: 1.3807,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0898 79.1494C32.2098 83.0394 36.7899 103.689 37.3699 108.039",
    stroke: "#FA5252",
    strokeWidth: 1.3807,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1299 117.75C38.8199 123.7 38.7898 131.58 38.3398 137.55",
    stroke: "#FA5252",
    strokeWidth: 1.095,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0195 123.109C70.1595 126.849 70.4495 135.879 70.5895 139.619",
    stroke: "#FA5252",
    strokeWidth: 1.3807,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.25 119.34C66.25 123.73 66.55 134.62 66.55 139.01",
    stroke: "#FA5252",
    strokeWidth: 1.3807,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9098 119.379L70.9497 112.899L43.8798 113.479L38.0098 121.219V125.359C38.0098 126.629 38.9897 127.709 40.3497 127.969C48.4997 129.519 57.9398 130.349 65.7998 128.639C66.8498 128.409 67.9198 128.129 68.7498 127.509C69.7498 126.759 70.2097 125.599 70.7397 124.519C71.9097 122.139 71.9098 119.379 71.9098 119.379Z",
    fill: "#FF6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5793 122.14C47.4193 124.82 59.6893 126.22 68.6093 123.73C70.0793 122.4 76.5893 110.54 73.6893 109.29C70.7893 108.04 46.1093 109.29 46.1093 109.29C46.1093 109.29 35.4093 121.18 38.5793 122.14Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6398 121.439L83.0498 141.279C83.0498 141.279 84.2598 143.279 85.6398 141.279C87.0198 139.279 91.0598 126.259 91.0598 126.259L85.6398 121.439Z",
    fill: "#FFA8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3998 103.379L78.0498 122.019L80.1198 110.279L85.6398 100.619L88.3998 103.379Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3899 111.509C83.4099 110.979 81.6898 111.439 80.8398 111.409L83.6099 101.449C85.5399 100.979 87.5499 101.719 89.3999 102.449C89.7199 102.579 90.0599 102.709 90.3099 102.949C90.5999 103.219 90.7499 103.599 90.8899 103.969C91.9099 106.739 92.2498 109.709 92.5898 112.649C93.1998 118.029 95.2299 140.789 95.6099 141.839C95.6499 141.959 92.6599 141.949 92.5599 142.039C92.5499 142.039 82.8799 124.089 83.3899 111.509Z",
    fill: "#FFC9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5502 102.85V97.25C62.5502 97.25 49.1501 95.94 45.6101 96.47C45.6101 96.47 39.7802 104.2 42.3902 112.41C43.8202 116.91 48.2102 119.8 52.9202 119.47C60.1202 118.97 72.7702 118.65 78.0502 122.01L80.1202 115.8L82.0002 112.03C83.5002 109.03 84.5902 105.85 85.2502 102.56L85.6402 100.61L62.5502 102.85Z",
    fill: "#FF6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5267 88.2446C78.3956 84.8127 87.4608 69.0826 83.7743 53.1104C80.0878 37.1382 65.0456 26.9723 50.1766 30.4042C35.3076 33.8361 26.2424 49.5662 29.9289 65.5384C33.6155 81.5105 48.6577 91.6764 63.5267 88.2446Z",
    fill: "#FFA8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2853 82.8658C74.3882 80.0724 81.7669 67.2679 78.766 54.2663C75.7651 41.2647 63.5211 32.9894 51.4182 35.7828C39.3152 38.5763 31.9366 51.3807 34.9375 64.3823C37.9384 77.3839 50.1824 85.6593 62.2853 82.8658Z",
    fill: "#FF6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8883 76.8147C69.8808 74.7392 75.3632 65.2258 73.1337 55.5661C70.9041 45.9064 61.8069 39.7582 52.8144 41.8337C43.822 43.9093 38.3396 53.4226 40.5692 63.0823C42.7987 72.742 51.8959 78.8902 60.8883 76.8147Z",
    fill: "#FFA8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9574 72.7808C66.8726 71.1847 71.0878 63.8662 69.3725 56.4344C67.6572 49.0026 60.6608 44.2718 53.7456 45.8679C46.8304 47.4639 42.6152 54.7825 44.3305 62.2143C46.0458 69.6461 53.0422 74.3769 59.9574 72.7808Z",
    fill: "#FF6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6193 89.5291L37.6193 80.4792L31.5293 77.0991C31.5293 77.0991 51.3893 60.8091 59.5393 62.7691C59.5393 62.7691 61.1693 64.7292 65.1193 66.7992C69.0693 68.8692 71.1393 65.4191 71.1393 65.4191C71.1393 65.4191 80.3292 67.0792 86.4392 88.6892L75.7793 95.1091L71.8292 88.2091L62.7793 97.0792L44.9993 95.9692L48.3593 84.0691L39.6193 89.5291Z",
    fill: "#FFA8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3096 67.29L63.5596 66.1C62.5496 65.85 58.7495 63.8 59.3895 62.97L64.5496 56.29L71.1095 58.44L69.2595 66.71C69.1495 67.13 68.7296 67.4 68.3096 67.29Z",
    fill: "#FFC9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1896 51.1599C73.1896 51.1599 72.3596 42.1799 66.5696 43.7899C62.0696 45.0399 60.4896 48.3499 60.8896 52.1499L59.7897 50.9599C57.1797 51.8599 59.0596 55.1999 59.2296 55.5899C59.3996 55.9799 59.7597 56.2599 60.1497 56.4399C60.7597 56.7099 61.4696 56.7099 62.0996 56.4999C63.1296 58.7199 64.8296 60.7199 67.1096 61.4799C68.1696 61.8299 69.3097 61.8499 70.4197 61.7899C70.7197 61.7699 71.0397 61.7499 71.3097 61.6099C71.5897 61.4599 71.7896 61.1999 71.9596 60.9399C73.9196 58.1299 74.3796 54.3599 73.1896 51.1599Z",
    fill: "#FFE3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.72 54.3696C57.64 53.9796 57.3301 51.6796 57.3801 50.5396C57.4301 49.3996 57.8501 48.2996 57.9101 47.1596C57.9601 46.1996 57.7701 45.2196 58.0601 44.3096C58.3801 43.3196 59.22 42.5896 60.08 42.0096C61.77 40.8896 63.7801 40.1496 65.8001 40.2996C66.8001 40.3796 67.8001 40.6996 68.6501 41.2296C70.3901 42.3196 70.9901 44.6896 69.6201 46.2096C68.9901 46.9096 67.9601 47.3296 66.3001 46.7796C62.1601 45.3996 65.4501 48.5796 63.1101 49.7496C60.7701 50.9196 61.8 51.6596 60.6 53.3596C59.41 55.0596 58.72 54.3696 58.72 54.3696Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1396 50.4493C69.5196 49.5693 70.4697 48.9793 71.4297 49.0393",
    stroke: "#FA5252",
    strokeWidth: 0.6903,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8701 51.8492C63.2801 51.0692 64.4301 50.8192 65.1301 51.3492",
    stroke: "#FA5252",
    strokeWidth: 0.6903,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0195 51.9197C70.2595 51.4797 70.8196 51.2397 71.2996 51.3797",
    stroke: "#FA5252",
    strokeWidth: 0.6903,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4297 53.5593C64.8197 53.2693 65.3197 53.1293 65.7997 53.1593",
    stroke: "#FA5252",
    strokeWidth: 0.6903,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3193 56.0694C68.3693 55.9194 68.4094 55.7594 68.4594 55.6094C68.5994 55.6094 68.7494 55.6094 68.8894 55.6094",
    stroke: "#FA5252",
    strokeWidth: 0.6903,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8896 58.8299C68.1496 58.0899 68.8696 57.5799 69.6396 57.3899C70.4096 57.1999 71.2096 57.2899 71.9796 57.4399C71.7196 58.1499 71.0696 58.6599 70.3596 58.9299C69.6496 59.1999 68.8796 59.2499 68.1296 59.2799",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.29 62.4697C60.13 63.4697 61.01 64.4397 61.92 65.3797C62.44 65.9197 62.9901 66.4697 63.6801 66.7797C64.2901 67.0597 64.97 67.1397 65.64 67.1397C68.13 67.1597 69.77 66.7797 71.15 65.3997",
    stroke: "#FA5252",
    strokeWidth: 1.3807,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2998 65.7695C58.7098 66.5295 56.3497 68.0595 54.6097 70.1195C54.1597 70.6495 53.7297 71.3495 53.9797 71.9995C54.1797 72.5295 54.7897 72.8195 55.3597 72.8095C55.9297 72.7995 56.4697 72.5595 56.9797 72.2995C58.5097 71.5395 59.9897 70.6695 61.3897 69.6895C62.1897 69.1295 63.0697 68.2295 62.7197 67.3195C60.5497 71.4595 58.1197 75.4795 55.4597 79.3195C53.9397 81.5195 52.2798 83.8095 52.0398 86.4695C51.9398 87.5195 52.0797 88.5795 51.9597 89.6295C51.7697 91.3895 50.8798 93.0795 51.0198 94.8495C53.8198 88.7995 56.6497 82.6895 60.7097 77.3895C61.9297 75.7995 63.2697 74.2695 64.0897 72.4395C64.6497 71.1995 64.9497 69.8395 64.9597 68.4695C64.9597 68.2295 64.9197 67.9295 64.6897 67.8395C63.7797 69.4695 64.2698 71.7395 65.7698 72.8395C66.3698 73.2795 67.1497 73.5495 67.8797 73.3695C68.6097 73.1895 69.2197 72.4895 69.1397 71.7395C69.0797 71.2695 68.7797 70.8795 68.4897 70.5095C67.6597 69.4395 66.8197 68.3795 65.9897 67.3095C67.1997 69.7495 69.3197 71.7195 71.8397 72.7495C73.2097 73.3095 74.8797 73.5695 76.0897 72.7095C77.0197 72.0495 76.6698 70.9295 78.0498 70.9295C75.9498 71.4095 74.4198 71.5095 72.2798 71.2895C70.1398 71.0695 67.9597 70.0095 66.9697 68.0995",
    stroke: "#FA5252",
    strokeWidth: 1.3807,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7192 62.6494C54.8692 62.2494 49.6493 64.8594 46.2893 66.7894C41.2293 69.7094 35.2893 72.6294 31.5293 77.0994C32.4793 78.2694 33.7393 79.1794 35.1493 79.7294",
    stroke: "#FA5252",
    strokeWidth: 1.3807,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6201 89.5291C44.2801 87.4291 48.5901 84.6491 52.8801 81.8691",
    stroke: "#FA5252",
    strokeWidth: 1.3807,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9794 84.3896C47.1094 88.3896 44.9194 93.0296 45.2394 97.0396",
    stroke: "#FA5252",
    strokeWidth: 1.3807,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5498 97.26C64.1498 94.66 66.2298 92.34 68.6498 90.47C69.8598 89.53 71.1598 88.7 72.2698 87.66C74.9198 85.17 76.3398 81.67 77.6798 78.29",
    stroke: "#FA5252",
    strokeWidth: 1.3807,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1497 88.3099C73.0397 90.4999 74.1696 92.5899 75.5096 94.5299C78.5596 91.6299 82.5296 89.7199 86.6896 89.1499C85.1396 86.3799 83.7496 83.5299 82.5096 80.6199C80.3296 75.4799 79.4196 68.1799 71.1396 65.4199",
    stroke: "#FA5252",
    strokeWidth: 1.3807,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9102 97.1699C47.6702 95.7899 52.6302 96.0299 54.2902 96.0199C55.7402 96.0099 57.1901 96.2199 58.6301 96.4399C60.0101 96.6499 61.4002 96.8599 62.7802 97.0699",
    stroke: "#FA5252",
    strokeWidth: 1.3807,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3901 117.88C35.2501 117.88 33.5001 111.1 33.2701 109.51C33.0601 108.03 33.41 106.52 33.33 105.03C33.26 103.65 32.8201 102.32 32.3801 101.01C31.0301 96.9496 29.6901 92.8996 28.3401 88.8396C27.6501 86.7496 26.9401 84.5796 27.1701 82.3896C27.4001 80.1996 28.8401 77.9696 31.0101 77.5596L34.7501 79.8996C33.5401 86.0896 34.1201 92.4996 35.4001 98.6796C35.6701 99.9896 35.9801 101.3 36.6001 102.48C37.1901 103.6 38.0401 104.57 38.7101 105.64C39.9001 107.55 40.5001 114.94 39.2501 114.94L38.1401 109.55L37.3701 112.6L39.3901 117.88Z",
    fill: "#FFC9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5293 79.8597C34.9493 79.6297 35.0593 78.6697 35.6093 78.3697C36.1593 78.0697 36.8393 78.2697 37.3793 78.5797C36.6993 80.9697 37.4493 83.4997 38.0993 85.8897C39.8693 92.3697 40.8093 107.6 41.1293 114.31",
    stroke: "#FA5252",
    strokeWidth: 1.3807,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1396 93.8093C36.2196 93.3093 39.1596 94.3393 39.4996 95.4793",
    stroke: "#FA5252",
    strokeWidth: 1.3807,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1801 77.0899C30.2501 76.6399 30.23 76.1399 29.95 75.7699C29.67 75.4099 29.0801 75.2699 28.7401 75.5899C28.4701 75.8499 28.4701 76.2699 28.4901 76.6399C28.5101 77.0299 28.58 77.5099 28.95 77.6599",
    stroke: "#FA5252",
    strokeWidth: 1.3807,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6201 80.4791C37.7901 80.1691 38.0001 79.8791 38.2401 79.6291C38.4501 79.3991 38.7101 79.1891 39.0101 79.1391C39.5501 79.0391 40.0902 79.4591 40.2902 79.9791C40.4902 80.4891 40.4501 81.0691 40.3801 81.6191C40.1201 80.3991 40.8301 79.0491 41.9801 78.5691C43.1301 78.0891 44.5901 78.5291 45.2701 79.5691C45.1601 78.7991 45.0502 78.0191 44.9302 77.2491C44.4702 77.4491 43.9901 77.6491 43.4801 77.6691C42.9701 77.6891 42.4301 77.5191 42.1501 77.1091C41.8501 76.6691 41.9101 76.0691 42.1101 75.5791C42.3101 75.0891 42.6301 74.6491 42.8601 74.1691C42.6301 73.9491 42.2501 74.0091 41.9601 74.1391C41.6701 74.2691 41.3901 74.4591 41.0701 74.4691C40.7501 74.4791 40.3901 74.1991 40.4901 73.8991C41.1001 72.6191 42.5301 71.8691 43.9501 71.7591C45.3701 71.6491 46.7701 72.0891 48.0801 72.6491C48.3601 72.7691 48.6601 72.9091 48.8501 73.1491C48.9901 73.3291 49.0701 73.5491 49.1301 73.7591C49.5101 75.0891 49.3301 76.5591 48.6501 77.7591C48.2201 78.5191 47.5901 79.1891 47.3901 80.0391C47.2001 80.8491 47.4502 81.7391 48.0302 82.3291C48.6102 82.9191 49.5002 83.1891 50.3102 83.0091",
    stroke: "#FA5252",
    strokeWidth: 1.3807,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.94 81.7198C49.49 81.8698 48.9901 81.5198 48.8501 81.0698C48.7101 80.6198 48.8701 80.1198 49.1101 79.7198C49.7201 78.7198 50.9201 78.1098 52.0901 78.2098C51.5301 77.7698 51.1902 77.0698 51.1802 76.3598C51.1702 75.6498 51.4901 74.9398 52.0301 74.4798C51.3801 74.8598 50.4501 74.6398 50.0401 74.0098",
    stroke: "#FA5252",
    strokeWidth: 1.3807,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5997 71.53C48.0197 71.04 47.8797 70.16 48.1197 69.43C48.3597 68.71 48.9197 68.13 49.5497 67.7C50.2097 67.25 51.0797 66.94 51.7797 67.3C52.1697 67.5 52.4497 67.89 52.6297 68.29C52.8197 68.7 52.9297 69.17 52.7797 69.6C52.6197 70.02 52.1196 70.33 51.7096 70.14C51.8896 69.71 51.6097 69.17 51.1697 69.02C50.7297 68.87 50.2097 69.1 49.9797 69.51C49.8197 69.8 49.7897 70.15 49.8097 70.48C49.8597 71.24 50.1697 72.02 50.7797 72.47C51.3897 72.92 52.3397 72.95 52.8697 72.4",
    stroke: "#FA5252",
    strokeWidth: 1.3807,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8197 75.6997C55.6197 75.4197 55.2298 75.3097 54.8898 75.3897C54.5498 75.4597 54.2598 75.6897 54.0498 75.9597C53.7598 76.3097 53.5798 76.7797 53.6698 77.2197C53.7598 77.6597 54.2098 78.0397 54.6598 77.9497",
    stroke: "#FA5252",
    strokeWidth: 1.3807,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8093 84.2195C47.2193 84.7295 46.3393 84.6994 45.5593 84.6294C45.2293 84.5994 44.8793 84.5695 44.6293 84.3595C44.1093 83.9295 44.2993 83.0995 44.1393 82.4395C43.9693 81.7495 43.2992 81.2095 42.5792 81.1895C42.4892 81.1895 42.3992 81.1894 42.3292 81.2394C42.2492 81.2894 42.2093 81.3794 42.1793 81.4594C41.9893 81.9494 41.9592 82.5195 42.1892 82.9995C42.4292 83.4695 42.9592 83.8095 43.4792 83.7295C43.4992 84.4095 42.8892 85.0395 42.2092 85.0495C41.5292 85.0595 40.9093 84.4395 40.9093 83.7595C41.1693 84.3895 40.9092 85.1394 40.4392 85.6294C39.9692 86.1194 39.3292 86.4194 38.6992 86.6694",
    stroke: "#FA5252",
    strokeWidth: 1.3807,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.04 85.9496C55.61 87.0796 57.1 87.5596 58.3 87.1496C59.49 86.7396 60.34 85.5896 60.59 84.3496C60.75 85.2796 60.3899 86.2396 59.8199 86.9896C59.2499 87.7396 58.4701 88.2996 57.6801 88.8196C58.5001 88.9096 59.32 88.9996 60.14 89.0896C59.32 89.5596 58.32 89.5896 57.38 89.5896C56.84 89.5996 56.3 89.5996 55.76 89.6096C56.5 91.3196 58.54 92.3496 60.36 91.9296C61.5 91.6596 62.47 90.9096 63.39 90.1796C62.76 90.6396 62.17 91.1596 61.63 91.7296C62.02 92.0896 62.63 92.0996 63.12 91.8996C63.61 91.6996 64 91.3296 64.38 90.9696C64 91.2996 63.65 91.7296 63.62 92.2296C63.59 92.7296 64.06 93.2696 64.54 93.1496",
    stroke: "#FA5252",
    strokeWidth: 1.3807,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5692 87.5594C71.0092 86.9594 71.0593 86.0894 70.6793 85.4494C70.2993 84.8094 69.5193 84.4194 68.7793 84.5194C69.9393 84.7094 71.1792 84.2794 71.9692 83.4094C71.7792 83.8994 71.8993 84.4794 72.2493 84.8594C72.6093 85.2394 73.1893 85.3894 73.6793 85.2394C73.0193 84.6694 72.6792 83.7494 72.8192 82.8794C73.3992 83.1394 74.0993 83.0794 74.6293 82.7294C74.0893 82.4394 73.5893 82.0694 73.1493 81.6394C73.0793 81.5694 73.0093 81.4894 73.0193 81.3994C73.0293 81.2594 73.1892 81.1994 73.3192 81.1694C74.0292 81.0194 74.7993 81.1694 75.4093 81.5694",
    stroke: "#FA5252",
    strokeWidth: 1.3807,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0498 75.3693C76.0598 75.4693 75.1498 75.9893 74.4298 76.6693C73.6998 77.3493 73.1297 78.1693 72.5697 78.9893C72.4997 78.6593 72.4197 78.3193 72.2097 78.0693C71.9997 77.8093 71.6097 77.6693 71.3197 77.8393C70.9197 78.0793 71.0097 78.6793 71.0697 79.1393C71.2897 80.8093 70.3497 82.5693 68.8297 83.3093C69.9897 81.4693 69.8698 78.9193 68.5498 77.1993C69.7598 77.3693 70.9997 77.0693 72.0897 76.5093C72.6097 76.2393 73.0998 75.8993 73.4298 75.4293C73.7598 74.9493 73.8998 74.3093 73.6698 73.7793",
    stroke: "#FA5252",
    strokeWidth: 1.3807,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1096 76.04C62.2396 76.98 62.5096 77.94 63.1096 78.68C63.7096 79.42 64.7096 79.89 65.6396 79.66C64.6396 79.7 63.7896 80.57 63.5796 81.55C63.3696 82.53 63.7197 83.57 64.3097 84.38C63.9197 83.92 63.4896 83.48 62.9496 83.21C62.4096 82.94 61.7296 82.89 61.2196 83.21C61.8496 82.58 61.9897 81.52 61.5597 80.74C61.9597 80.43 62.3596 80.02 62.3796 79.51C62.4096 78.81 61.7296 78.32 61.1196 77.96C60.9496 77.86 60.7696 77.75 60.5996 77.65",
    stroke: "#FA5252",
    strokeWidth: 1.3807,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6097 80.0195C59.8097 80.1395 59.8897 80.3795 59.9397 80.6095C60.3097 82.4995 58.9398 84.5495 57.0498 84.9295C57.1798 84.9095 57.2998 84.8995 57.4298 84.8795",
    stroke: "#FA5252",
    strokeWidth: 1.3807,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7693 91.6295C78.0193 91.9895 78.5892 91.8695 78.9692 91.6495C79.4892 91.3595 80.0093 90.8795 79.9993 90.2795C79.9993 89.7895 79.6292 89.3495 79.1892 89.1295C78.7492 88.8995 78.2493 88.8395 77.7593 88.7895C78.3193 88.5495 78.7592 88.0695 78.9592 87.4895C78.6092 88.0195 79.0992 88.7995 79.7192 88.8895C80.3492 88.9795 80.9592 88.5695 81.3192 88.0495C81.7992 87.3495 81.9393 86.3795 81.5093 85.6395C81.0793 84.9095 80.0392 84.5495 79.3192 84.9995C79.7292 84.4795 79.5893 83.6695 79.1593 83.1595C78.7293 82.6495 78.0892 82.3795 77.4492 82.1695C77.8492 82.3695 78.3992 81.9895 78.3492 81.5495C78.5592 82.2495 79.4793 82.5695 80.1493 82.2895C80.8193 81.9995 81.2193 81.2495 81.2593 80.5195",
    stroke: "#FA5252",
    strokeWidth: 1.3807,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5997 78.1093C80.0697 77.7493 79.4398 77.5493 78.7998 77.5193C79.2198 77.3293 79.5098 76.8793 79.5198 76.4193C79.5298 75.9593 79.2597 75.4993 78.8497 75.2793",
    stroke: "#FA5252",
    strokeWidth: 1.3807,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2093 85.2998C75.0093 85.9898 75.4793 86.7998 76.1793 86.9598C75.5693 87.1698 75.0193 87.6598 74.8993 88.2898C74.7793 88.9198 75.2393 89.6498 75.8793 89.6898C75.0993 89.8598 74.6093 90.8298 74.9293 91.5598C75.2493 92.2898 76.2892 92.5898 76.9492 92.1298",
    stroke: "#FA5252",
    strokeWidth: 1.3807,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.79 95.0996C77.56 94.4196 84.59 89.6096 86.34 88.8896",
    stroke: "#FA5252",
    strokeWidth: 1.3807,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2594 89.5693C87.6294 91.5193 90.7893 95.3693 92.8293 98.6793C94.8493 101.959 96.8794 105.239 98.8994 108.519C100.209 110.649 101.549 112.849 101.899 115.329C102.139 117.059 101.879 118.819 101.589 120.549C101.419 121.549 101.209 122.619 100.489 123.339C99.2294 124.599 96.6794 126.839 96.0494 126.099L98.7894 121.959C99.2494 120.399 99.2494 118.709 98.7994 117.149C98.2594 118.599 97.6893 120.039 97.0793 121.459C96.8693 121.949 96.3994 122.549 95.9194 122.299C96.0594 120.839 96.1993 119.379 96.3293 117.919C96.4293 116.869 96.5294 115.799 96.9594 114.839C97.3094 114.029 97.8994 113.259 97.8694 112.379C97.8294 111.349 96.9793 110.559 96.1893 109.889C94.9493 108.849 93.0794 106.489 91.8394 105.439L87.6993 101.299C83.6993 98.3193 81.7594 97.0393 80.1094 92.3293",
    fill: "#FFC9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1896 113.689C41.0596 117.139 40.8896 138.499 41.1296 141.939",
    stroke: "#FA5252",
    strokeWidth: 1.3807,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.279 144.9C124.879 146.27 125.319 148.51 126.319 145.74C127.319 142.97 135.399 120.57 137.239 116.07L130.379 107.83L126.259 121.56C121.249 132.12 122.139 140.78 122.139 144.9",
    fill: "#FFC9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.1 112.97C141.03 119.62 141.02 138.89 140.67 145.59C140.67 145.59 144.99 149.72 144.98 147.18C144.97 144.48 145.59 141.82 146.14 139.18C147.58 132.27 148.28 121.26 148.83 114.22",
    fill: "#FFC9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.779 87.62C124.879 92.97 124.789 98.39 123.439 103.57C123.109 104.84 122.699 106.2 123.139 107.44C123.579 108.68 125.309 109.5 126.239 108.57C127.229 107.58 126.589 105.44 127.859 104.83C128.849 105.46 129.069 107.2 128.869 108.54C128.669 109.88 128.349 111.35 129.039 112.52C129.569 113.42 130.579 113.9 131.349 114.61C131.939 115.16 132.469 115.89 133.259 116.02C133.659 116.09 134.059 115.99 134.459 115.93C136.839 115.59 139.139 116.73 141.499 117.2C146.099 118.12 151.139 116.28 154.069 112.62C154.649 111.9 155.149 111.1 155.429 110.21C155.679 109.4 155.729 108.54 155.769 107.7C155.919 104.84 156.069 101.97 155.769 99.12C155.499 96.61 154.889 94.14 154.829 91.62C154.789 90.09 154.959 88.56 154.969 87.02C154.979 85.05 154.729 83.08 154.469 81.12C153.919 76.9 153.369 72.66 152.239 68.56C151.929 67.44 151.559 66.3 150.769 65.46C149.019 63.6 146.039 63.92 143.519 64.38C140.649 64.91 137.779 65.43 134.919 65.96C133.689 66.19 126.589 72.02 126.029 70.89C124.459 72.07 124.759 76.66 124.699 78.44C124.599 81.5 124.719 84.56 124.779 87.62Z",
    fill: "#FF6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.819 35.6896C119.629 43.7996 120.019 51.9296 120.979 59.9896C121.069 60.7396 121.169 61.4896 121.449 62.1896C121.809 63.0496 122.439 63.7696 122.969 64.5496C125.139 67.7296 125.509 71.7796 126.989 75.3296C127.839 77.3696 129.059 79.2396 130.289 81.0896C130.789 81.8296 132.639 85.6696 132.609 86.7596C132.509 89.9896 133.839 92.5296 135.109 95.4996C135.109 95.4996 139.379 97.8396 140.099 96.7496L138.849 90.5096C138.849 90.5096 141.349 94.2596 141.349 93.0096L140.099 90.5096L135.109 81.7696L131.359 66.7796L127.629 61.1796L130.109 51.7896L133.859 44.2996L128.869 29.3096L125.429 29.7396C122.569 30.4896 120.399 32.7996 119.819 35.6896Z",
    fill: "#FFC9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.05 94.68C155.09 95.49 157.64 93.4 158.36 92.2C159.13 90.91 159.03 89.27 159.64 87.89C159.8 87.53 160 87.19 160.06 86.8C160.12 86.43 160.04 86.06 159.96 85.7C158.97 81.21 157.97 76.71 156.59 72.33C155.77 69.74 154.82 67.15 154.59 64.45C154.45 62.72 154.61 60.96 154.32 59.24C154.06 57.75 153.47 56.34 152.99 54.91C151.72 51.15 151.18 47.19 150.66 43.26L148.73 34.76C148 31.56 145.3 29.2 142.03 28.91L137.33 28.5L126.38 29.3L135.88 37.83L139.84 45.15L145.49 51.56H149.61L151.44 65.1L153.65 74.25L156.35 81.75C156.35 81.75 155.1 87.99 155.1 89.24C155.1 89.68 156.35 87.99 156.35 87.99C156.35 87.99 155.97 87.77 156.35 87.99C157.47 88.62 156.35 92.99 156.35 92.99L155.05 94.68Z",
    fill: "#FFC9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.58 10.1299C148.57 10.7999 148.35 11.5299 148.68 12.1099C148.88 12.4699 149.25 12.6999 149.61 12.9199C150.82 13.6399 152.08 14.3399 153.04 15.3699C154 16.3999 154.65 17.8399 154.36 19.2199C154.29 19.5499 154.17 19.8899 154.25 20.2199C154.4 20.8299 155.12 21.0499 155.65 21.3799C156.62 21.9999 157.06 23.2699 156.84 24.3899C156.61 25.5099 155.79 26.4699 154.77 26.9999C154.02 27.3899 153.16 27.5699 152.32 27.5199C151.93 27.4999 151.53 27.4199 151.15 27.5299C150.7 27.6499 150.36 27.9999 150.01 28.2899C149.3 28.8799 148.43 29.3099 147.51 29.3999C146.59 29.4799 145.62 29.1899 144.98 28.5199C144.6 28.1199 144.15 27.2199 143.71 27.5499C141.35 29.3099 138.95 27.0099 138.85 26.8099C138.13 25.2999 139.33 23.4199 138.85 21.8099C138.58 20.8999 140.68 20.7499 140.26 19.8999C139.77 18.8999 139.67 17.7599 139.59 16.6499C139.53 15.9099 139.48 15.1399 139.68 14.4199C140.24 12.3999 142.62 11.3399 143.32 9.35991C143.76 8.13991 143.76 5.34991 145.78 5.56991C147.34 5.73991 148.6 8.81991 148.58 10.1299Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.759 31.5496C138.619 28.2196 140.099 25.5596 141.359 22.7296L133.859 16.8096C132.309 20.2796 129.889 24.3796 128.869 28.0496C128.869 28.0496 132.439 34.0396 138.619 32.1596",
    fill: "#FFA8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.359 4.31934C141.849 4.31934 145.979 6.92934 146.349 8.06934C146.689 9.09934 146.489 11.9893 146.349 13.0693C146.079 15.1893 146.849 15.8193 146.069 17.8193C145.679 18.8293 145.279 19.8493 144.889 20.8593C144.489 21.8993 144.049 22.9793 143.189 23.6993C142.999 23.8593 142.779 23.9993 142.539 24.0593C142.239 24.1293 141.919 24.0793 141.619 23.9993C137.949 23.1193 135.079 19.5893 134.969 15.8193C133.969 16.3393 132.639 16.1193 131.869 15.2993C131.099 14.4793 130.939 13.1393 131.509 12.1693",
    fill: "#FFC9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.97 12.6697C138.88 11.5397 140.77 11.3797 141.86 12.3497",
    stroke: "#FA5252",
    strokeWidth: 0.6863,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.05 19.3C143.03 18.95 144.8 17.93 145.18 19.37C144.79 19.3 144.79 20.68 143.42 20.68C142.55 20.67 141.91 20.16 142.05 19.3Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.819 12.6498C145.189 11.7798 146.119 11.1898 147.059 11.2198",
    stroke: "#FA5252",
    strokeWidth: 0.6863,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.65 57.0194C144.56 56.8194 144.2 56.9094 144.17 57.1294C144.13 57.3494 144.35 57.5394 144.57 57.5594C144.79 57.5694 144.99 57.4494 145.16 57.3094C145.33 57.1694 145.46 56.9894 145.64 56.8594",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.259 51.7202C142.139 51.5302 141.799 51.6902 141.789 51.9102C141.779 52.1402 141.989 52.3102 142.209 52.3902C142.499 52.4902 142.849 52.4402 143.029 52.2002",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.379 48.2296C139.249 48.1496 139.079 48.1296 138.939 48.1796C138.859 48.3596 138.899 48.5896 139.039 48.7296C139.179 48.8696 139.409 48.9096 139.589 48.8296",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.77 44.21C136.73 44.48 136.86 44.78 137.08 44.94C137.3 45.1 137.62 45.13 137.87 45.02",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.579 42.0801C135.589 42.1901 135.719 42.2701 135.819 42.2301C135.729 42.1801 135.65 42.1301 135.56 42.0901",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.979 52.65C146.909 52.65 146.849 52.66 146.779 52.66C146.739 52.77 146.859 52.9 146.989 52.89C147.109 52.89 147.219 52.8 147.299 52.71C147.209 52.66 147.089 52.64 146.979 52.65Z",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.739 49.3096C147.809 49.5496 148.169 49.6496 148.349 49.4696",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.769 57.5898C137.649 57.8598 137.739 58.2298 137.999 58.3598C138.259 58.4898 138.649 58.2698 138.609 57.9798",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.8 53.9496C136.02 53.9696 136.24 53.8396 136.33 53.6396",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.82 49.2295C133.81 49.3895 133.83 49.5495 133.89 49.7095C134.09 49.7095 134.28 49.5995 134.38 49.4295C134.19 49.3595 134.01 49.2895 133.82 49.2295Z",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.47 57.75C130.62 58.06 130.86 58.33 131.15 58.51",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.639 73.1201C143.559 73.1401 143.469 73.1201 143.399 73.0801C143.679 73.2201 144.029 73.2401 144.319 73.1101",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.22 72.3799C147.32 72.6999 147.87 72.7299 148 72.4199",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.239 71.9699C151.369 71.8699 151.489 71.7699 151.619 71.6699",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.66 62.2397C151.64 62.0697 151.62 61.8997 151.59 61.7197C151.16 63.4297 151.22 65.2697 151.77 66.9497",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.51 95.9297C154.96 97.9297 155.4 99.9297 155.85 101.93C155.92 102.25 156 102.59 156.18 102.86C156.39 103.19 156.75 103.46 156.77 103.85C156.78 104.13 156.61 104.42 156.71 104.68C156.78 104.88 156.98 104.99 157.15 105.1C157.53 105.35 157.87 105.69 158.03 106.12C158.19 106.55 158.14 107.07 157.82 107.4C157.25 108 156.2 107.7 155.48 108.12C155.14 108.32 154.9 108.67 154.62 108.94C154.34 109.21 153.92 109.44 153.55 109.3C153.13 112.12 152.72 114.94 152.3 117.76C151.9 116.37 151.5 114.97 151.1 113.58C151.31 115.32 151.06 117.12 150.38 118.74",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.649 114.279C148.709 115.939 148.639 117.609 148.439 119.259C148.429 119.339 148.319 119.449 148.289 119.359",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.909 113.75C147.129 115.74 146.979 117.76 146.489 119.69",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.469 114.75C144.849 116.73 144.859 118.77 144.519 120.76C144.449 120.71 144.389 120.65 144.319 120.6",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.559 115.12C142.669 117.05 142.669 118.99 142.559 120.93C142.549 121.05 142.489 121.21 142.369 121.18",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.56 116.1C140.17 117.82 140.789 119.65 140.329 121.35C140.299 121.45 140.25 121.57 140.15 121.59C140.12 121.51 140.09 121.43 140.06 121.36",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.16 115.49C138.08 117.24 138.05 118.99 138.07 120.75C137.94 120.71 137.85 120.58 137.85 120.44",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.76 115.64C136.25 117.31 136.599 119.1 136.469 120.84C136.459 120.94 136.429 121.06 136.339 121.07C136.229 120.94 136.13 120.8 136.02 120.67",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.429 114.96C134.269 116.73 134.259 118.51 134.379 120.28C134.319 120.13 134.259 119.99 134.199 119.84",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.97 114.66C133.02 116.43 133.05 118.2 133.06 119.96C132.96 119.97 132.85 119.88 132.84 119.78",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.86 114.66C131.87 116.41 131.84 118.15 131.76 119.89C131.71 119.74 131.66 119.6 131.6 119.45",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.42 105.27C141.1 104.96 141.95 105.07 142.52 105.54C143.09 106.01 143.36 106.83 143.19 107.55C143.32 107.12 143.46 106.68 143.73 106.31C144 105.94 144.41 105.65 144.86 105.66C145.49 105.67 145.96 106.22 146.34 106.72C146.61 105.64 147.92 104.96 148.96 105.35C149.07 104.47 149.85 103.56 150.71 103.79C150.96 103.86 151.18 104.02 151.39 104.18C151.73 104.43 152.07 104.68 152.4 104.93",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.14 103.319C153.19 102.969 153.27 102.589 153.56 102.389C153.93 102.149 154.46 102.359 154.69 102.729C154.92 103.099 154.91 103.579 154.84 104.009",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.219 97.0898C151.359 98.5798 151.349 100.09 151.209 101.58",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.56 86.21C150.9 86.33 151.3 86.23 151.54 85.96",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.149 84.2998C146.339 84.3498 146.549 84.3498 146.739 84.2998C146.539 84.2998 146.339 84.2998 146.149 84.2998Z",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.949 87.8799C143.229 87.8799 143.509 87.8799 143.789 87.8799",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.979 84.5301C139.879 84.2401 139.829 83.9401 139.819 83.6401C139.819 83.4501 139.839 83.2401 139.939 83.0801C140.039 82.9201 140.249 82.8101 140.429 82.8701C140.449 83.3101 140.619 83.7401 140.889 84.0801",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.689 82.2402C150.649 82.0102 150.879 81.7702 151.109 81.7902C151.339 81.8102 151.519 82.0902 151.439 82.3102",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.959 105.73C135.679 105.65 135.479 105.36 135.499 105.07C135.219 105.06 134.949 105.19 134.789 105.42C134.669 105.59 134.619 105.8 134.509 105.98C134.399 106.16 134.209 106.32 134.009 106.28C133.749 106.23 133.649 105.87 133.779 105.63C133.909 105.39 134.179 105.28 134.429 105.21C134.949 105.07 135.499 105.07 136.039 105.09C136.409 105.1 136.799 105.13 137.109 105.32C137.429 105.51 137.639 105.93 137.479 106.26",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.419 107.59C135.969 107.53 136.399 108.06 136.649 108.56C136.859 108.97 136.999 109.53 136.679 109.86C136.499 110.04 136.229 110.1 135.969 110.11C135.649 110.12 135.339 110.09 135.029 110.01",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.659 108.8C134.899 109 135.089 109.26 135.189 109.56",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.26 107.609C140.45 107.289 140.97 107.319 141.23 107.579C141.49 107.839 141.57 108.239 141.62 108.609C141.7 109.189 141.73 109.849 141.32 110.269C140.91 110.689 140.22 110.679 139.67 110.469",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.909 109.41C139.879 109.51 139.859 109.61 139.829 109.71",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.539 108.95C144.679 109.5 145.119 110.07 145.689 110.02C145.929 110 146.139 109.87 146.339 109.74C146.799 109.46 147.249 109.18 147.709 108.89",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.15 107.819C148 108.109 148.05 108.479 148.25 108.729C148.46 108.979 148.81 109.089 149.12 108.989",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.25 106.91C150.95 107.02 150.77 107.36 150.78 107.68C150.79 108 150.96 108.3 151.18 108.54C151.48 108.87 151.9 109.1 152.34 109.12C152.78 109.13 153.24 108.89 153.42 108.48",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.459 106.819C153.499 107.069 153.729 107.269 153.979 107.289",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.659 106.439C155.809 106.569 155.959 106.689 156.119 106.819",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.109 113.29C142.259 113.34 142.409 113.39 142.569 113.44",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.56 111.99C150.71 111.93 150.81 111.78 150.8 111.62",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.8 16.2695C143.31 16.1595 143.81 16.0495 144.32 15.9395",
    stroke: "#FA5252",
    strokeWidth: 0.6863,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.88 100.29C143.18 100.44 143.49 100.59 143.79 100.75",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.38 95.7402C145.76 95.9702 146.14 96.2002 146.52 96.4302",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.59 92.9795C148.82 92.9795 149.05 92.9795 149.29 92.9795C149.05 92.9795 148.82 92.9795 148.59 92.9795Z",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.949 77.0098C137.419 77.3598 137.969 77.5998 138.549 77.6898",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.34 73.6201C136.03 73.8301 136.72 74.0401 137.41 74.2501",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.449 78.1197C148.109 78.3997 148.909 78.3197 149.509 77.9297",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.659 112.609C135.419 112.779 136.169 112.949 136.929 113.119",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.159 112.149C145.769 112.149 146.379 112.149 146.989 112.149",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.659 13.6093C145.859 13.0593 146.599 12.7993 147.099 13.1093",
    stroke: "#FA5252",
    strokeWidth: 0.6863,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.239 13.9001C139.499 13.8501 139.659 13.5702 139.909 13.4602C140.129 13.3602 140.399 13.4301 140.599 13.5701C140.799 13.7101 140.949 13.9002 141.099 14.1002",
    stroke: "#FA5252",
    strokeWidth: 0.6863,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.04 13.0698C133.35 13.2798 134.69 12.7898 135.75 11.9898C136.8 11.1898 137.6 10.0998 138.32 8.98977C138.52 8.67977 138.72 8.35977 139.04 8.16977C139.42 7.94977 139.88 7.94977 140.32 7.95977C141.99 7.95977 143.66 7.76977 145.29 7.37977C146.62 7.05977 148.19 6.20977 148.02 4.85977C147.96 4.40977 147.7 3.99977 147.39 3.66977C146.31 2.49977 144.64 2.00977 143.05 2.00977C141.46 2.00977 139.9 2.45977 138.37 2.89977C138.37 2.89977 134.08 2.93976 132.54 7.52977C131 12.1198 132.04 13.0698 132.04 13.0698Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.139 8.03932C128.569 9.10932 128.42 10.3493 127.93 11.4593C127.24 12.9993 125.929 14.1693 124.569 15.1593C123.199 16.1493 121.729 17.0093 120.509 18.1693C119.979 18.6693 119.489 19.2693 119.389 19.9893C119.289 20.6593 119.55 21.3493 119.42 22.0193C119.16 23.3393 117.52 23.9893 117.16 25.2893C117.06 25.6593 117.08 26.0493 117.16 26.4193C117.46 27.7093 118.589 28.6993 119.839 29.1293C121.089 29.5593 122.549 29.4793 123.859 29.2993C125.169 29.1293 126.279 30.6093 127.609 30.5493C128.769 30.4993 130.07 28.8793 131.16 28.4893C132.93 27.8593 134.049 25.7793 133.589 23.9493C133.369 23.0493 132.81 22.1493 133.06 21.2593C133.35 20.1993 134.59 19.7593 135.43 19.0493C136.23 18.3793 136.719 17.3593 136.749 16.3193C136.799 14.7093 135.819 13.0993 136.269 11.5493C136.639 10.2693 137.909 9.38932 138.209 8.08932C138.489 6.85932 137.799 5.31932 136.999 4.39932C136.319 3.60932 135.709 3.69932 134.829 4.11932C132.779 5.05932 130.279 5.90932 129.139 8.03932Z",
    fill: "#FA5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.64 29.4097C126.64 29.4097 137.76 41.7997 128.58 50.7997L128.39 61.9097L132.11 69.8397L151.78 66.9597L151.35 56.7697L149.42 50.6997L150.1 41.7897V38.0397L146.35 34.2897L140.11 29.2897C140.11 29.2897 140.11 29.2897 143.86 33.0397C145.75 34.9297 147.08 39.3397 146.73 45.0797C146.42 50.3197 145.48 50.1797 145.48 50.1797L142.55 48.9797L141.35 44.2797L137.6 40.5297L135.1 36.7797L132.22 34.6997L127.3 29.2197L126.64 29.4097Z",
    fill: "#FF6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.479 28.6699C145.719 33.6699 146.79 39.7399 146.77 43.9999C146.76 46.6599 146 49.2499 145.24 51.7999C145.6 51.1899 145.209 50.3499 144.589 49.9899C143.969 49.6299 143.22 49.6199 142.51 49.6099C142.76 48.2099 141.919 46.6799 140.599 46.1499C141.579 45.0699 140.609 43.3299 139.439 42.4499C138.269 41.5699 136.79 40.7699 136.56 39.3299C136.48 38.8199 136.57 38.2799 136.39 37.7999C136.01 36.7699 134.69 36.5599 133.68 36.1099C131.54 35.1399 128.469 30.6899 126.939 28.9099",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.12 67.9495C133.76 67.9895 133.5 67.4995 133.68 67.1795C133.86 66.8595 134.33 66.7995 134.64 66.9895C134.95 67.1795 135.1 67.5595 135.1 67.9295C135.71 67.7195 136.45 68.2295 136.48 68.8795C137.21 67.6795 139.15 67.4895 140.09 68.5295C140.24 68.0695 140.4 67.5995 140.7 67.2095C141 66.8295 141.47 66.5395 141.95 66.5895C142.65 66.6695 143.09 67.3795 143.3 68.0595C143.89 67.5195 144.84 67.4095 145.54 67.7995C145.9 66.6595 147.59 66.2295 148.45 67.0595C148.85 66.8095 149.24 66.5595 149.64 66.3095C150.24 65.9395 151 65.5495 151.61 65.9095C152.28 66.3095 152.2 67.3995 151.61 67.9095C151.02 68.4195 150.16 68.4695 149.39 68.3695C149.63 69.2095 148.66 69.9495 147.79 69.9395C146.92 69.9295 146.13 69.4695 145.28 69.2595C145.01 69.1895 144.72 69.1495 144.45 69.2195C143.97 69.3395 143.63 69.7595 143.19 69.9695C142.8 70.1495 142.36 70.1495 141.93 70.1395C141.01 70.1295 140.09 70.1195 139.17 70.1195C137.97 70.1095 136.74 70.0895 135.64 69.6095",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.359 62.0201C140.989 62.5601 142.069 62.4701 142.599 61.8301C142.719 61.6801 142.839 61.5001 143.029 61.4901C143.139 61.4801 143.229 61.5401 143.319 61.5901C143.699 61.8201 144.019 62.1401 144.409 62.3501C144.799 62.5601 145.309 62.6401 145.679 62.3801C146.079 62.1001 146.249 61.4701 146.729 61.4301C147.089 61.4001 147.359 61.7301 147.649 61.9501C148.289 62.4301 149.299 62.3201 149.819 61.7101C149.949 61.5501 150.099 61.3501 150.299 61.3601C150.449 61.3701 150.569 61.5001 150.699 61.5701C151.189 61.8301 151.779 61.2401 151.739 60.6901C151.699 60.1401 151.289 59.7001 150.899 59.3001C151.959 58.4801 151.939 56.6301 150.869 55.8301",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.82 55.1199C150.94 54.6499 150.52 54.1299 150.04 54.1499C150.25 52.9899 149.35 51.8799 149.41 50.6999C149.43 50.2599 149.59 49.8399 149.69 49.4199C149.86 48.6999 149.86 47.9399 149.71 47.2099C149.59 46.6699 149.38 46.1299 149.38 45.5699C149.38 44.5999 150 43.7599 150.24 42.8199C150.48 41.8799 149.98 40.5799 149.02 40.6699C149.67 39.9499 150.18 38.9699 149.97 38.0199C149.76 37.0699 148.58 36.3399 147.76 36.8799C148.08 35.9099 146.77 35.6799 144.47 33.6699",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.68 39.9297C127.83 40.5197 127.77 41.7397 127.79 42.7797C127.94 48.7697 128.09 54.7497 128.24 60.7397C128.25 61.2497 129.06 62.9297 129.36 63.2697",
    stroke: "#FA5252",
    strokeWidth: 1.3727,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFashionRightImage);
export default __webpack_public_path__ + "static/media/fashionRightImage.b03569107909405d38016bfef7abcb66.svg";
export { ForwardRef as ReactComponent };